import CardTableLabaRugi from "components/Cards/CardTableLabaRugi";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { getDropdownTahunValue } from "views/admin/masterData/dataTahun/api/dataTahunAPI";
import { getLaporanLabaRugi } from "./api/labaRugiAPI";

export default function LabaRugi() {
  const [formData, setFormData] = useState({
    tahun: new Date().getFullYear(),
  });

  const [dataLaba, setDataLaba] = useState([]);
  const [dataRugi, setDataRugi] = useState([]);
  const [totalLaba, setTotalLaba] = useState(0);
  const [totalRugi, setTotalRugi] = useState(0);

  // Select-Option Data
  const [dropdownTahunAnggaran, setDropdownTahunAnggaran] = useState([]);

  const [isExportable, setIsExportable] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses..");
    } else {
      toast.dismiss();
    }

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  // Set Inputted Data to Form
  const setData = (value) => {
    setFormData({ tahun: value });
  };

  // Select-Option Data
  // Load Dropdown Tahun Anggaran Pemasukan
  useEffect(() => {
    setIsLoading(true);
    getDropdownTahunValue()
      .then((response) => {
        setDropdownTahunAnggaran(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));
  }, []);

  const handleGetLaporanLabaRugi = (e) => {
    e.preventDefault();
    setIsLoading(true);
    console.log(formData);
    getLaporanLabaRugi(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  //Handle when submit process end
  const endSubmitProcess = () => {
    setIsLoading(false);
  };

  // Check if Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setDataLaba(result.data.data.dataLaba);
        setDataRugi(result.data.data.dataRugi);
        setTotalLaba(result.data.data.totalLaba);
        setTotalRugi(result.data.data.totalRugi);
        setIsExportable(true);
      } else {
        setIsExportable(false);
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
    }
    setResult(null);
  }, [result]);

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <Toaster />
          <CardTableLabaRugi
            tableTitle="Laporan Laba Rugi"
            setData={setData}
            formData={formData}
            dataLaba={dataLaba}
            dataRugi={dataRugi}
            totalLaba={totalLaba}
            totalRugi={totalRugi}
            isExportable={isExportable}
            dropdownTahun={dropdownTahunAnggaran}
            handleSubmit={handleGetLaporanLabaRugi}
          />
        </div>
      </div>
    </div>
  );
}
